import { useEffect } from "react";
import { useUser } from "@clerk/react";
import { analytics, analyticsConsent, HEYCATCH_SURFACE } from "@/lib/heycatch";

const SIGNUP_SENT = "cr_hc_signup";
const IDENTIFIED = "cr_hc_ident";

// Identity for the app project: set after sign-in, cleared once after sign-out.
export const HeyCatchIdentity = () => {
  const { isLoaded, isSignedIn, user } = useUser();
  useEffect(() => {
    if (!isLoaded || HEYCATCH_SURFACE !== "app") return;
    if (isSignedIn && user) {
      localStorage.setItem(IDENTIFIED, "1");
      const created = user.createdAt ? new Date(user.createdAt) : null;
      analytics.setIdentity(user.id, { email: user.primaryEmailAddress?.emailAddress, name: user.fullName || undefined },
        created ? { signup_date: created.toISOString() } : undefined);
      if (created && Date.now() - created.getTime() < 60 * 60 * 1000 && localStorage.getItem(SIGNUP_SENT) !== user.id && analyticsConsent()) {
        localStorage.setItem(SIGNUP_SENT, user.id);
        analytics.trackEvent("signup_completed");
      }
    } else if (!isSignedIn && localStorage.getItem(IDENTIFIED)) {
      localStorage.removeItem(IDENTIFIED);
      analytics.resetIdentity();
    }
  }, [isLoaded, isSignedIn, user]);
  return null;
};
